import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../hooks/useTranslation';

type MilitaryAddressTooltipProps = {
  isOpen: boolean;
  closeTooltip: () => void;
  anchorEl: HTMLElement | null;
};

const MilitaryAddressTooltip = ({
  isOpen,
  closeTooltip,
  anchorEl,
}: MilitaryAddressTooltipProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={closeTooltip}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Grid container spacing={0} direction="row-reverse">
        <Grid item xs={1}>
          <IconButton onClick={closeTooltip}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid item xs={11}>
          <Box padding={`${theme.spacing(2)}px`}>
            <Typography
              variant="h3"
              style={{
                paddingBottom: theme.spacing(1),
                fontWeight: 'bold',
              }}
            >
              {t('CUSTOMER_ASSISTANCE_REQUIRED')}
            </Typography>
            <Typography variant="body1">
              {t('FOREIGN_OR_MILITARY_ADDRESS_REQUIRE_ASSISTANCE')}
            </Typography>
            <Typography variant="body1">
              {t('ASSISTANCE')}{' '}
              <a href={`tel:${t('PGE_PHONE')}`}>{`${t('PGE_PHONE')}.`}</a>
            </Typography>
            <Typography variant="body1" style={{ marginTop: theme.spacing(2) }}>
              {t('BUSINESS_CUSTOMER_ASSISTANCE_LEAD_IN')}{' '}
              <a href={`tel:${t('BUSINESS_CUSTOMER_SERVICE_NUMBER')}`}>{`${t(
                'BUSINESS_CUSTOMER_SERVICE_NUMBER',
              )}.`}</a>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default MilitaryAddressTooltip;
